import { graphql, type ResultOf } from '@tucan/graphql'

export const PROFILE_FRAGMENT = graphql(`
  fragment Profile on Profile @_unmask {
    allowPasswords
    avatar: avatarUrl(size: 250)
    email
    hasMsteams
    hasZoom
    id
    isStaff
    lang
    lastLogin
    firstName
    lastName
    onboardingDone: setting(key: "onboarded")
  }
`)

export type ProfileFragment = ResultOf<typeof PROFILE_FRAGMENT>
